import React, { Component } from "react";
import Header from "./Header";
import Desc from "./description";
import SelectDataType from "../containers/SelectDataType";
import "react-select/dist/react-select.css";
import WinchSelection from "./winchSelection";
import SelectionAndSelectedContainer from "./selectionAndSelectedContainer";
import { connect } from "react-redux";
import Datasheet from "./dataSheet";
import { updatePreviewStatus } from "../actions";
// import 'bootstrap/dist/css/bootstrap.min.css';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPreview: false
    };
  }

  componentDidUpdate(prevState) {
    if (prevState !== this.props) {
      if (this.props.previewHtml) {
        this.setState(
          {
            showPreview: true
          },
          () => {
            this.props.onShowPreview("show");
          }
        );
      } else {
        this.setState(
          {
            showPreview: false
          },
          () => {
            this.props.onShowPreview(null);
          }
        );
      }
    }
  }

  render() {
    var innerHtml = this.props.previewHtml;
    var refresh = this.state.showPreview;
    return (
      <div>
        {!this.state.showPreview && (
          <div className="maincontainer">
            <Header />
            <Desc />
            <SelectDataType />
            <WinchSelection refresh={!refresh} />
            <SelectionAndSelectedContainer />
          </div>
        )}
        {this.state.showPreview && <Datasheet previewHtml={innerHtml} />}
      </div>
    );
  }
}

const mapActionsToProps = {
  onShowPreview: updatePreviewStatus
};

const mapStateToProps = state => {
  return { previewHtml: state.previewHtml };
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(App);



// WEBPACK FOOTER //
// ./src/components/App.js